import { render, staticRenderFns } from "./StatusRemocao.vue?vue&type=template&id=792f6513&scoped=true"
import script from "./StatusRemocao.vue?vue&type=script&lang=js"
export * from "./StatusRemocao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "792f6513",
  null
  
)

export default component.exports